import { SkillValue } from "../../../services/api/instances/skillsApi/types";
import { generateId } from "../../../shared/utils/generateId";
import { TSkillField, TSkillFieldType } from "../types";

export const INIT_SKILL_VALUE: SkillValue = {
  skill_object: {
    name: "",
    friendly_name: "",
    description: "",
    path: "",
    instruction: "",
    tags: [],
  },
};

export const SKILL_BASE_FIELD: TSkillField[] = [
  {
    id: generateId(),
    label: "Техническое имя (на английском языке, без пробелов)",
    placeholder: "Введите значение",
    value: "",
  },
  {
    id: generateId(),
    label: "Когда нужно вызывать",
    placeholder: "Введите значение",
    value: "",
    rows: 5,
  },
  {
    id: generateId(),
    label: "Инструкция",
    placeholder: "Введите значение",
    value: "",
    rows: 30,
  },
];
